import type { Field } from "@fobu/schema";

export interface A11y {
  id: string;
  describedBy: string | undefined;
  invalid: boolean;
  labelId: string;
}

export interface FieldProps<F extends Field = Field> {
  field: F;
  value: unknown;
  onChange: (value: unknown) => void;
  a11y: A11y;
  /** Conversational/Funnel: Tastenkürzel, Auto-Weiter. */
  conversational: boolean;
  onAdvance: () => void;
}

/** Tastenkürzel A, B, C … für Optionen im Conversational-Modus. */
export const keyFor = (i: number) => (i < 26 ? String.fromCharCode(65 + i) : "");
